<template>
  <div>
      <full-page  ref="fullpageContact" :options="options" id="fullpage">

        <div id="section000"  class="section">
          <h2>LOADING...</h2>

        </div>


 <div id="section122" class="section">
<div class="prodWrap">
          <b-container>
           <b-row class="h-100 align-items-center justify-content-center">
<b-col>
            <b-row>
              <b-col><h1>PRESS CONTACTS</h1></b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                  
                  <b-card class="text-center">
                      <p ><b>Devon Sanceda</b></p>
                        <p class="contactInfo">STARZ ENTERTAINMENT<br><a href="tel:424-204-4050" target="_blank">424-204-4050</a><br><a href="mailto:Devon.Sanceda@Starz.com" target="_blank">Devon.Sanceda@Starz.com</a></p>
                  </b-card>
              </b-col>
              <b-col md="6">

                  <b-card class="text-center">
                      <p ><b>Courtney Jacobs</b></p>
                        <p class="contactInfo">STARZ ENTERTAINMENT<br><a href="tel:424-204-4111" target="_blank">424-204-4111</a><br><a href="mailto:Courtney.Jacobs@Starz.com" target="_blank">Courtney.Jacobs@Starz.com</a></p>
                  </b-card>
              </b-col>
              <b-col md="6">
                  <b-card class="text-center">
                      <p ><b>Anthony McLaughlin</b></p>
                        <p class="contactInfo">STARZ ENTERTAINMENT<br><a href="tel:424-204-4099" target="_blank">424-204-4099</a><br><a href="mailto:Anthony.McLaughlin@Starz.com" target="_blank">Anthony.McLaughlin@Starz.com</a></p>
                  </b-card>

              </b-col>
            </b-row>
</b-col>
           </b-row>
          </b-container>
</div>
        </div>
      </full-page>
  </div>
</template>

<script>

export default {
  name: 'Contact',
  metaInfo: {
    title: 'Contact' // set a title
  },
  data () {
    return {
      options: {
        licenseKey: '08F6AFDB-F75D4F5A-AE124C87-3D28719F',
        menu: '#menu',
        anchors: ['loading', 'contact'],
        slidesNavigation: true,
        controlArrows: true,
        scrollOverflow: true,
        lazyLoading: false,
        onLeave: this.onLeave,
        afterLoad: this.afterLoad
      }
    }
  },
  methods: {
    afterLoad (origin, destination, direction) {
      if (destination.index === 0) {
        this.$refs.fullpageContact.api.moveSectionDown()
      }
    },
    onLeave (origin, destination, direction) {
      if (destination.index === 0) {
        document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.remove('logo')
      }
      if (origin.index === 1 && destination === 'up') {
        document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.remove('logo')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../styles/PressContacts.scss";
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue